<div class="row no-gutter details">
  <!-- <div class="first"> -->
  <!-- <div class="imageDiv"> -->
  <div class="outerClass">
    <img src="../../../../assets/images/add-site-banner.svg" />
    <img src="../../../../assets/images/close-circle.svg" (click)="close()" class="cursor-pointer close" alt="" />
  </div>
<!-- </div> -->
<!-- <div class="col-lg-1 col-md-1">
<img
  src="../../../../assets/images/close-circle.svg"
  (click)="close()"
  class="cursor-pointer close"
  alt=""
  />
</div> -->
<!-- </div> -->
<div class="station-form-container">
  <div class="fm-title col-xs-12">
    {{ data == "Sites" ? "Add New" : "Edit" }} Site
  </div>
  <div class="newSite">
    <form class="user-form" [formGroup]="editForm" autocomplete="off">
      <div class="form-group col-xs-5 col-sm-3 col-md-3">
        <label for="sitecode">Site Code</label>
        <input class="form-control siteInput text-capitalize" formControlName="sitecode" placeholder="Site Code"
          type="text" minlength="2" maxlength="30" autocomplete="off" required />
          <div class="error-section">
            @if (
              editForm.controls.sitecode.errors &&
              (editForm.controls.sitecode.touched ||
              editForm.controls.sitecode.dirty)
              ) {
              <p class="err-msg" [hidden]="!editForm.get('sitecode').hasError('required')">
                Site Code is required
              </p>
            }
          </div>
        </div>
        <div class="form-group stateSelect col-xs-5 col-sm-3 col-md-3">
          <label for="state">State</label>
          <mat-select disableRipple placeholder="State" class="form-control" [(value)]="selectedState"
            formControlName="state" (selectionChange)="stateSelected($event)">
            @for (state of states; track state) {
              <mat-option value="{{ state }}" class="option">
                <span>{{ state }}</span>
              </mat-option>
            }
          </mat-select>
          <div class="error-section">
            @if (
              editForm.controls.state.errors &&
              (editForm.controls.state.touched ||
              editForm.controls.state.dirty)
              ) {
              <p class="err-msg" [hidden]="!editForm.get('state').hasError('required')">
                State is required
              </p>
            }
          </div>
        </div>
        <div class="form-group col-xs-5 col-sm-3 col-md-3">
          <label for="city">City</label>
          <mat-select disableRipple placeholder="City" class="form-control" [(value)]="selectedCity"
            formControlName="city">
            @for (city of cityArray; track city) {
              <mat-option value="{{ city }}" class="option">
                <span>{{ city }}</span>
              </mat-option>
            }
          </mat-select>
          <div class="error-section">
            @if (
              editForm.controls.city.errors &&
              (editForm.controls.city.touched || editForm.controls.city.dirty)
              ) {
              <p class="err-msg" [hidden]="!editForm.get('city').hasError('required')">
                City is required
              </p>
            }
          </div>
        </div>
        <div class="form-group col-xs-5 col-sm-3 col-md-3">
          <label for="region">Region</label>
          <mat-select disableRipple placeholder="Region" class="form-control" [(value)]="selectedRegion"
            formControlName="region" (selectionChange)="regionSelected($event)">
            @for (region of regionCode; track region) {
              <mat-option value="{{ region }}" class="option">
                <span>{{ region }}</span>
              </mat-option>
            }
          </mat-select>
          <div class="error-section">
            @if (
              editForm.controls.region.errors &&
              (editForm.controls.region.touched ||
              editForm.controls.region.dirty)
              ) {
              <p class="err-msg" [hidden]="!editForm.get('region').hasError('required')">
                Region is required
              </p>
            }
          </div>
        </div>
        <div class="form-group col-xs-5 col-sm-3 col-md-3">
          <label for="type">Type</label>
          <mat-select disableRipple [(value)]="selectedType" class="form-control" formControlName="type"
            placeholder="Type">
            @for (type of typesArray; track type) {
              <mat-option value="{{ type }}" class="option">
                <span>{{ type }}</span>
              </mat-option>
            }
          </mat-select>
          <div class="error-section">
            @if (
              editForm.controls.type.errors &&
              (editForm.controls.type.touched || editForm.controls.type.dirty)
              ) {
              <p class="err-msg" [hidden]="!editForm.get('type').hasError('required')">
                Type is required
              </p>
            }
          </div>
        </div>
      </form>
      <div class="button">
        <button type="submit" class="create-action" [ngClass]="editForm.valid ? 'hover-action' : ''"
          (click)="onSubmit()" [disabled]="editForm.invalid || editForm.pristine">
          <span>Submit</span>
        </button>
      </div>
    </div>
  </div>
</div>